// Centralized field styling constants using CSS variables
export const inputFieldSx = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "var(--bg-input)",
    color: "var(--text-primary)",
    "& fieldset": {
      borderColor: "var(--border-default)",
    },
    "&:hover fieldset": {
      borderColor: "var(--border-hover)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--accent)",
    },
  },
  "& .MuiInputBase-input::placeholder": {
    color: "var(--text-secondary)",
    opacity: 1,
  },
  "& .MuiFormLabel-root": {
    color: "var(--text-secondary)",
  },
};

export const disabledFieldSx = {
  ...inputFieldSx,
  cursor: "not-allowed",
  "& .MuiOutlinedInput-root.Mui-disabled": {
    backgroundColor: "var(--bg-input)",
    opacity: 0.6,
  },
};

export const selectFieldSx = {
  backgroundColor: "var(--bg-input)",
  color: "var(--text-primary)",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "var(--border-default)",
    },
    "&:hover fieldset": {
      borderColor: "var(--border-hover)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--accent)",
    },
  },
};

export const getSelectSx = (disabled = false) => {
  const baseSx = selectFieldSx;
  if (disabled) {
    return {
      ...baseSx,
      "& .MuiOutlinedInput-root.Mui-disabled": {
        opacity: 0.6,
      },
    };
  }
  return baseSx;
};
